import React, { useState } from "react";
import get from "lodash/get";
import { RadioPageOulu } from "../radio-page/radio-page-oulu";
import { RadioPagePori } from "../radio-page/radio-page-pori";
import { RadioPageLapua } from "../radio-page/radio-page-lapua";
import { RadioPageTurku } from "../radio-page/radio-page-turku";
import { RadioPageLohja } from "../radio-page/radio-page-lohja";
import { RadioPageLahti } from "../radio-page/radio-page-lahti";
import { RADIOT_CLICKED, RADIOT_YLEISOHJELMA } from "../../store/actions";
import { RadioPageTornio } from "../radio-page/radio-page-tornio";
import { RadioPageKajani } from "../radio-page/radio-page-kajani";
import { ResponsiveImage } from "@quintype/components";
import { useDispatch, useSelector } from "react-redux";
import { RadioPageHelsinki } from "../radio-page/radio-page-helsinki";
import { RadioPageRovaniemi } from "../radio-page/radio-page-rovaniemi";
import { RadioPageKruunupyy } from "../radio-page/radio-page-kruunupyy";
import { RadioPageYleisohjelma } from "../radio-page/radio-page-yleisohjelma";
import { RadioPageKristiinankaupunki } from "../radio-page/radio-page-kristiinankaupunki";
import { useEffect } from "react";

// 1. IMPORT THE CUSTOM HOOK (3 LEVELS UP)
import { useRadioChannelData } from "../../../hook/useRadioChannelData";

const RadioValtakunnallinenPage = (props) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: RADIOT_YLEISOHJELMA,
      isRadiotYleisohjelmaClicked: true,
    });
  }, [dispatch]);
  const { channelData } = useRadioChannelData("mobile-radio-valtakunnallinen", props.data?.radioChannelData);
  const content = channelData?.content || [];
  const paragraphs = content.filter((item) => item.type === "paragraph");
  const subheadings = content.filter((item) => item.type === "subheading");

  const style = `
    .channel-specific-radio-image {
      height: 50px;
      width: 50px;
      background: #a20d39;
      border-radius: 10px;
      padding:5px;
      margin: 5px;
    }

    .channel-specific-button {
      background:#a20d39;
      border:none;
      border-radius:10px;
      color: #fff;
      cursor: pointer;
      padding:10px;
      font-size:20px;
      margin: 5px;
    }

    .channel-specific-buttons-wrapper {
      display: flex;
      justify-content: center;
    }

    .top-banner-static-image::before {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 20%;
      pointer-events: none;
        background: linear-gradient(
        to bottom,
        rgba(0, 0, 0, 1) 0%,
        rgba(0, 0, 0, 1) 45%,
        rgba(0, 0, 0, 0.8) 60%,
        rgba(0, 0, 0, 0) 100%
      );
      -webkit-mask-image: linear-gradient(to bottom, black 0%, transparent 100%);
      mask-image: linear-gradient(to bottom, black 20%, transparent 90%);
    }
    .contentTitle {
      content: '';
      width:100%;
      margin: 0 auto;
      position: absolute;
      bottom:0;
      left: 0;
      justify-content: flex-start;
      background: linear-gradient(to top, rgba(0, 0, 0, 1) 5%, rgba(0, 0, 0, 0.75) 25%, rgba(0, 0, 0, 0.3) 50%, rgba(0, 0, 0, 0.01) 85%);
      color: white;
      box-sizing: border-box;
      padding: 0 3rem;
      min-height: 150px;
    }
    .top-banner-static-image {
      margin: 0 0 30px;
      text-align: center;
      position: relative;
      height: 800px;
    }
    .top-banner-static-image img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
    .radio-container {
      font-family: "Montserrat", sans-serif;
      color: #FFF;
      margin: 30px 30px 0px 30px;
    }

    .radio-container h1 {
      font-family: "Montserrat", sans-serif;
    }

    .radio-container h2, .static-page-container h3 {
      margin-top: 3rem !important;
      color: #a20d39;
      font-family: "Montserrat", sans-serif;
    }

    .radio-container p {
      margin: 0.5rem 0 !important;
      font-size: 18px;
      font-family: "Montserrat", sans-serif;
    }

    .radio-container h3 {
      font-size: 22px !important;
      font-family: "Montserrat", sans-serif;
    }

    .radio-container a {
      color: #a20d39;
      font-weight: bold;
    }

    .custom-hero-container {
      position: relative;
      text-align: center;
      color: white;
      background-image: url("/assets/Valtakunnallinen-hero.jpg");
      background-size: cover;
      background-position: center;
      height: 500px;
      margin-bottom: 20px;
    }

    .custom-hero-heading {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      margin: 0;
      font-size: 2em;
      width: 80%
    }

    .location-img {
      text-align: center;
    }

    .mhz {
      text-align: right;
      color: #a20d39;
    }
    .mhz h2{font-weight: 600;font-size:32px}
    .map-hero-container {
      position: relative;
      text-align: center;
      color: white;
      background-image: url("/assets/Valtakunnallinen-web.jpg");
      background-size: cover;
      background-position: right top;
      height: 380px;
    }

    .portrait-mobile-image {
      display: none;
    }

    .custom-hero-heading h3 {
      font-size: 52px  !important;
      color: #FFF;
      font-family: "Montserrat", sans-serif !important;
      font-weight: 600;
    }
    .custom-hero-heading p {
      font-size: 20px !important;
      font-weight: 500;
      color: #FFF;
    }

    .main-headline-content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      position: absolute;
      bottom: 0;
      width: calc(100% - 60px);
   }
  .main-headline-content p {margin-bottom: 0;}
  .main-headline-content h1 {font-size: 32px !important;font-weight: 600}
  .main-headline-content h1,.main-headline-content h2{font-family: "Montserrat", sans-serif !important;}
   .staticContent {
      display: flex;
    }
    .columnLeft, .columnRight {width: 50%}
    .columnLeft{padding: 20px 50px 0 0;}
    .mobileSubHeadline {display: none;font-weight:600}
    .desktopSubHeadline {text-align: left;font-weight:600}
    .mhz h2{font-size: 26px}
    @media screen and (max-width: 768px) {
      .custom-hero-container {
        background-image: url("/assets/Valtakunnallinen-heromobiili.jpg");
      }
      .map-hero-container {
        background-image: url("/assets/Valtakunnallinen-mobile.jpg");
        background-position: bottom center;
        height: 600px;
      }
      .big-desktop-image {
        display: none;
      }
      .portrait-mobile-image {
        display: block;
      }
      .contact-item {
        width: 100% !important;
      }
      .top-banner-static-image {
        height: 675px;
      }
    }
    @media screen and (max-width: 1023px) {
      .main-headline-content {display:block;text-align: center;}
      .mhz{text-align:center}
      .staticContent {display: block;}
      .columnLeft {padding: 0 0 20px;text-align: center;}
      .columnLeft, .columnRight {width: 100%;}
      .columnRight .location-img {margin: 20px -30px 0}
      .desktopSubHeadline{display: none;}
      .mobileSubHeadline {display: block;}
      .main-headline-content {width: calc(100% - 40px)}
      .main-headline-content h2 {margin-top: 0 !important;}
      .radio-container{margin-bottom: -50px !important;}
      .custom-hero-heading h3 {font-size: 30px !important;}
      .contentTitle {padding-left:20px !important;padding-right:20px !important;}
    }
  `;

  return (
    <>
      <style dangerouslySetInnerHTML={{ __html: style }} />
      <div className="top-banner-static-image">
        <div className="custom-hero-heading">
          <h3>Radio Dei - enemmän toivoa</h3>
          <p>Sisältöä, joka luo toivoa, uskoa ja yhteyttä.</p>
        </div>
        <img src="/assets/Valtakunnallinen-hero.jpg" className="big-desktop-image" />
        <img src="/assets/Valtakunnallinen-heromobiili.jpg" className="portrait-mobile-image" />

        <div className="contentTitle">
          <div className="main-headline-content">
            <div>
              <h1>Radio Dei valtakunnallinen</h1>
            </div>
            <div className="mhz">
              {/* DYNAMIC FREQUENCY FROM BOLD */}
              <h2>{channelData?.frequency}</h2>
            </div>
          </div>
        </div>
      </div>

      <div className="radio-container">
        <div className="staticContent">
          <div className="columnLeft">
            {/* 1. KEEP YOUR EXISTING FIRST <h2> EXACTLY AS IT IS. */}
            <h2 className="firstH2Oulu">Radio Dei Valtakunnallinen</h2>

            {/* 2. ADD THIS DYNAMIC MAP LOOP TO REPLACE THE REST */}
            {content.map((item, index) => {
              if (item.type === "paragraph") {
                return <p key={index}>{item.text}</p>;
              }
              if (item.type === "subheading") {
                return <h2 key={index}>{item.text}</h2>;
              }
              // Ignore images and main headings!
              return null;
            })}
          </div>

          <div className="columnRight">
            <div className="location-img">
              <div className="map-hero-container">&nbsp;</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { RadioValtakunnallinenPage };
